import { callApi } from "./api.service";

// Define the function to Get Figs data (Token required)
export const GetListingData = async (
  user_id: string,
  getToken?: () => Promise<string | null>
) => {
  if (getToken) {
    const endpoint = `/api/listing/celebrity?user_id=${user_id}`;
    return await callApi(endpoint, "GET", true, getToken);
  } else {
    const endpoint = `/api/public/listing/celebrity?user_id=${user_id}`;
    return await callApi(endpoint, "GET", false);
  }
};

export const GetListingProfile = async (
  getToken?: () => Promise<string | null>
) => {
    const endpoint = `/api/listing/profile`;
    return await callApi(endpoint, "GET", true, getToken);
};

export const GetInternalIDByPublicID = async (public_id: string) => {
  const endpoint = `/api/listing/get-internal-id?public_id=${public_id}`;
  return await callApi(endpoint, "GET", false); 
};

export const AddEmailForNotify = async (
  data: any
) => {
  const endpoint = `/api/listing/get-notify/add`;
  return await callApi(endpoint, "POST", false, undefined, data); 
};

export const IsAlreadyAddedEmail = async (
  data: any
) => {
  const endpoint = `/api/listing/get-notify/check`;
  return await callApi(endpoint, "POST", false, undefined, data); 
};
